import React from "react"
import clsx from "clsx"
import { Link } from "react-router-dom"
import { FaHome } from "react-icons/fa"
import { useTranslation } from "react-i18next"

import classes from "./Breadcrumb.module.scss"
import ContextHelp from "./ContextHelp"

const Breadcrumb = props => {
  const { title, items = [], helpGuide } = props

  const [t] = useTranslation()

  return (
    <div className={classes["container"]}>
      <li className={classes["item"]}>
        <Link to="/">
          <FaHome />{" "}
          {t("خانه")}
        </Link>
      </li>

      <span style={{ color: "#6c757d" }}>
        /
      </span>

      <li
        className={clsx(classes["item"], classes["active"])}
        aria-current="page"
      >
        {title}
        {helpGuide && <ContextHelp guide={helpGuide} />}
      </li>

      {items.map(item =>
        <li
          key={item}
          className={clsx(classes["item"], classes["active"])}
          aria-current="page"
        >
          {item}
        </li>
      )}
    </div>
  )
}

export default Breadcrumb
